<main class="forgot-password__layout">
  <div class="main__container">
    <div>
      <img src="./../../../assets/images/new-logo-bmg.svg" width="300" alt="Logo BMG">
    </div>
    <aside class="aside__container">
      <div class="image__forgot-password">
        <img src="./../../../assets/images/new-logo-bmg.svg" alt="Logo BMG">
      </div>
    </aside>
    <aside class="aside__container">
      <router-outlet></router-outlet>
    </aside>
  </div>
</main>
